import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		male: {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=male&exp=web_price_before_scratch_small_funnels~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_price_before_scratch_small_funnels/male/__b'),
			},
		},
		'male-water-fasting': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=male-water-fasting&exp=web_price_before_scratch_small_funnels~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_price_before_scratch_small_funnels/male-water-fasting/__b'),
			},
		},
		'activity-female-yoga': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-yoga&exp=web_price_before_scratch_small_funnels~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_price_before_scratch_small_funnels/activity-female-yoga/__b'),
			},
		},
		'activity-male-chair-workouts': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-chair-workouts&exp=web_price_before_scratch_small_funnels~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_price_before_scratch_small_funnels/activity-male-chair-workouts/__b'),
			},
		},
		'activity-male-tai-chi-walking-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-walking-al&exp=web_price_before_scratch_small_funnels~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_price_before_scratch_small_funnels/activity-male-tai-chi-walking-al/__b'),
			},
		},
		'activity-male-walking': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-walking&exp=web_price_before_scratch_small_funnels~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_price_before_scratch_small_funnels/activity-male-walking/__b'),
			},
		},
		'activity-male-tai-chi-yoga-al': {
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-al&exp=web_price_before_scratch_small_funnels~1
			paywall: {
				experiment: () =>
					import('@/modules/Paywall/instances/experiments/web_price_before_scratch_small_funnels/activity-male-tai-chi-yoga-al/__b'),
			},
		},
	},
]

export default config
